module.exports = __webpack_public_path__ + "static/img/gb231.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gb231.png
// module id = CKg/
// module chunks = 0